import React, { Component } from 'react';
import Dialog from './../../UiComponents/Dialog';
import styles from './attachmentView.module.scss';

class AttachmentView extends Component {
    render() {
        let isFooterNeeded = false, isCloseButtonNeeded = true;

        return (
            <Dialog
                overlayClassName={styles.dialog}
                containerClassName={styles['overlay-container']}
                onClose={this.props.closeAttachment}
                isFooterNeeded={isFooterNeeded}
                isCloseButtonNeeded={isCloseButtonNeeded}
            >
                <div className={styles['attachment-img']}>
                    <img src={this.props.src} className={styles['marketing-img']} />
                </div>
            </Dialog>
        )
    }
}

export default AttachmentView;


// WEBPACK FOOTER //
// /src/components/commonComponents/attachmentView/AttachmentView.js